import { forwardRef, type Ref, type SVGProps } from "react";

function SvgUnlock(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <path
        stroke="url(#unlock_svg__a)"
        strokeWidth={10}
        d="M66.286 49.333v-16C66.286 21.551 76.007 12 88 12s21.714 9.551 21.714 21.333V38.5M60.857 108h54.286c5.996 0 10.857-4.776 10.857-10.667V60c0-5.891-4.861-10.667-10.857-10.667H60.857C54.861 49.333 50 54.11 50 60v37.333C50 103.224 54.86 108 60.857 108Z"
      />
      <path
        fill="#0D2B57"
        d="M41.975 2.975a.975.975 0 1 0-1.95 0c0 4.056-.895 6.754-2.595 8.455-1.7 1.7-4.399 2.595-8.455 2.595a.975.975 0 1 0 0 1.95c4.056 0 6.754.895 8.455 2.595 1.7 1.7 2.595 4.399 2.595 8.455a.975.975 0 1 0 1.95 0c0-4.056.895-6.754 2.595-8.455 1.7-1.7 4.399-2.595 8.455-2.595a.975.975 0 1 0 0-1.95c-4.056 0-6.754-.895-8.455-2.595-1.7-1.7-2.595-4.399-2.595-8.455"
      />
      <path stroke="#0C1C43" strokeLinecap="round" d="M88 69v14" />
      <defs>
        <linearGradient
          id="unlock_svg__a"
          x1={88}
          x2={88}
          y1={12}
          y2={108}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#98CCFB" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgUnlock);
export default ForwardRef;
